import React from 'react';

const Window = (props: { children: React.ReactNode; title: string; className: string }) => {
  const { children, title, className } = props;

  return (
    <div className={`window ${className}`}>
      <WindowSVG />
      <div className="window-content">
        <h3>{title}</h3>
        {children}
      </div>
    </div>
  );
};

const WindowSVG = () => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="481.79px"
    height="431.608px"
    viewBox="0 0 481.79 431.608"
    enable-background="new 0 0 481.79 431.608"
    xmlSpace="preserve"
  >
    <g>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M60.042,430.005c-1.326,0-2.652,0-3.978,0c-0.021-5.974-0.042-11.947-0.063-17.92
		c0.837-3.288-1.419-2.962-3.436-2.966c-10.084-0.019-20.169-0.05-30.255-0.076c-0.069-2.151-0.199-4.303-0.199-6.452
		c-0.01-124.105-0.009-248.21-0.008-372.313c0-1.161,0.1-2.328-0.003-3.479c-0.313-3.474,1.273-4.637,4.665-4.573
		c8.281,0.157,16.568,0.074,24.853,0.015c2.037-0.015,4.665,0.566,4.414-2.971c0.785-6.268-0.818-12.666,1.027-18.876
		c0.663,0,1.326,0,1.989,0c0.313,0.338,0.624,0.677,0.936,1.015c0.024,1.984,0.106,3.969,0.059,5.95
		c-0.056,2.325,1.383,2.218,2.973,1.957c2.655,0.009,5.311,0.019,7.966,0.027c4.31-3.602,8.619-3.749,12.928,0.001
		c1.616,0.054,3.244,0.002,4.845,0.184c4.139,0.47,5.75-1.188,4.667-5.281c0.073-0.988,0.146-1.977,0.22-2.965l0.1-0.123
		c2.668-0.599,3.569,0.663,3.541,3.176c-0.055,4.946,0.062,9.896-0.017,14.843c-0.04,2.531,0.707,3.843,3.461,2.974
		c0.828,0.031,1.656,0.087,2.483,0.087c91.448,0.007,182.896,0.01,274.345,0.009c0.993,0,1.986-0.034,2.979-0.071
		c1.967-0.074,2.498-1.292,2.38-3.017c0.022-4.952,0.046-9.903,0.069-14.854c-0.221-0.945-0.441-1.892-0.662-2.837l0.008-0.007
		c3.861-1.343,4.574,0.717,4.36,3.944c-0.162,2.41-0.279,4.941,3.493,3.888c2.347-0.02,4.693-0.038,7.04-0.057
		c1.778,0.68,2.483-0.552,3.186-1.79l-0.021,0.07c4.221-3.439,7.173,0.808,10.667,1.764c1.483,0.076,2.98,0.055,4.449,0.244
		c4.17,0.539,5.397-1.363,4.448-5.178c0.61-1.25-0.268-2.906,1.083-3.952c0.663,0,1.325,0,1.989,0
		c0.311,0.34,0.621,0.679,0.931,1.019c0.02,5.955,0.093,11.91,0.03,17.863c-0.022,2.179,0.351,3.641,2.999,2.975
		c11.521,0.071,23.041,0.143,34.562,0.213c0.028,2.152,0.082,4.306,0.082,6.457c0.004,110.312,0.004,220.623,0.004,330.935
		c0,14.741-0.164,29.485,0.101,44.222c0.078,4.267-1.318,5.248-5.327,5.126c-9.434-0.287-18.886,0.082-28.317-0.214
		c-3.418-0.107-4.252,0.952-4.135,4.124c0.209,5.624,0.063,11.261,0.065,16.893c-1.325,0-2.652,0-3.978,0
		c-0.037-1.354-0.073-2.705-0.11-4.058c1.426-3.245,0.837-5.066-3.179-4.827c-3.365,0.202-6.701-0.508-9.421,2.799
		c-1.702,2.069-4.885,1.796-6.651-0.321c-3.639-4.362-8.392-2.731-12.334-1.97c-3.346,0.647-1.074,4.898-1.848,7.426
		c-0.097,0.314-0.18,0.634-0.27,0.951c-0.994,0-1.989,0-2.983,0c-0.114-1.371-0.23-2.741-0.345-4.11
		c-0.003-4.631-0.005-9.26-0.008-13.891c0.796-3.961-2.215-2.852-4.043-2.853c-92.631-0.058-185.264-0.054-277.895-0.157
		c-2.965-0.004-3.639,0.991-3.684,3.677c-0.097,5.777,0.588,11.58-0.433,17.334c-0.995,0-1.989,0-2.983,0
		c-0.134-1.394-0.268-2.788-0.402-4.182c0.249-1.661,1.482-4.3-1.051-4.396c-3.661-0.139-7.935-2.142-10.995,1.965
		c-1.045,1.403-2.795,1.655-4.467,1.823c-1.026-0.495-2.396-0.725-3.023-1.531c-3.491-4.492-8.414-2.924-12.284-2.007
		c-3.32,0.787-1.032,5.133-1.603,7.833C59.996,429.668,60.036,429.84,60.042,430.005z M408.01,415.114
		c0.398,1.112,0.979,2.041,2.273,2.245c1.617,0.104,3.248,0.109,4.848,0.333c4.529,0.632,5.938-1.385,4.907-5.588
		c0.65-2.62-0.756-3.041-2.965-3.032c-9.112,0.035-18.226,0.045-27.334-0.129c-2.524-0.047-3.41,0.995-3.018,3.195
		c0.379,2.114-1.799,6.032,3.297,5.212c2.732,0.448,5.468,0.481,8.209,0.07c2.916-2.325,5.903-4.319,9.786-2.063L408.01,415.114z
		 M71.044,417.383c4.27-3.476,8.535-3.685,12.798,0.011c1.447,0.094,2.904,0.113,4.34,0.294c4.444,0.56,6.447-1.104,5.346-5.708
		c0.66-2.755-1.03-2.877-3.063-2.874c-9.189,0.012-18.378,0.007-27.566-0.118c-2.123-0.029-3.385,0.726-2.766,2.763
		c0.593,1.952-2.415,5.821,2.685,5.618C65.559,417.815,68.301,417.827,71.044,417.383z M63.028,22.274
		c8.743-0.01,17.486-0.009,26.229-0.039c2.159-0.007,4.588,0.247,4.194-3.176c-0.188-1.91,1.893-5.143-0.902-5.44
		c-3.732-0.396-8.112-2.123-11.447,2.011c-1.727,2.142-4.915,2.571-6.628,0.44c-3.422-4.256-7.8-2.47-11.841-2.718
		c-3.601-0.221-2.619,2.722-2.562,4.616C60.129,19.856,58.644,23.213,63.028,22.274z M390.14,22.175
		c8.513,0.023,17.026,0.075,25.539,0.047c2.029-0.006,4.618,0.513,4.267-2.998c-0.092-1.946,2.084-5.145-0.585-5.555
		c-3.538-0.545-7.765-2.103-11.04,1.602c-1.975,2.234-5.085,3.07-7.011,0.751c-3.473-4.183-7.808-2.536-11.841-2.666
		c-4.191-0.135-2.544,3.36-2.823,5.497C386.314,21.383,386.904,23.249,390.14,22.175z M152.68,97.091
		c3.522-0.835,7.995,1.66,10.523-2.499c8.258-13.583,16.315-27.289,24.463-40.939c1.632-2.733,0.399-3.538-2.251-3.524
		c-3.313,0.018-6.64,0.188-9.933-0.063c-3.923-0.299-6.37,1.096-8.387,4.618c-6.416,11.208-13.25,22.177-19.771,33.326
		c-1.463,2.5-4.807,5.322-3.452,7.755C145.461,98.613,149.664,96.362,152.68,97.091z M322.495,49.99
		c-3.44,0.932-7.891-1.753-10.452,2.472c-8.245,13.594-16.332,27.281-24.484,40.931c-1.593,2.668-0.458,3.579,2.239,3.566
		c3.478-0.017,6.974-0.215,10.43,0.07c3.861,0.318,6.012-1.37,7.88-4.614c6.442-11.194,13.199-22.208,19.718-33.359
		c1.464-2.506,4.881-5.249,3.52-7.723C329.758,48.45,325.556,50.738,322.495,49.99z M260.157,97.102
		c3.476-0.926,7.988,1.751,10.519-2.394c8.289-13.575,16.352-27.287,24.495-40.95c1.528-2.564,0.599-3.643-2.201-3.626
		c-3.479,0.02-6.972,0.175-10.436-0.067c-3.579-0.249-5.789,1.091-7.604,4.226c-6.559,11.326-13.408,22.485-20.043,33.77
		c-1.474,2.506-4.869,5.3-3.559,7.704C252.887,98.623,257.111,96.354,260.157,97.102z M224.679,97.071
		c3.358-0.878,7.767,1.718,10.323-2.518c8.195-13.575,16.27-27.221,24.383-40.845c1.569-2.637,0.44-3.587-2.256-3.576
		c-3.469,0.014-6.954,0.201-10.402-0.074c-3.824-0.306-6.024,1.298-7.897,4.549c-6.429,11.163-13.196,22.131-19.656,33.276
		c-1.513,2.611-5.17,5.452-3.54,8.101C217.174,98.487,221.48,96.531,224.679,97.071z M188.503,97.093
		c3.514-0.851,7.989,1.674,10.519-2.487c8.261-13.581,16.319-27.286,24.467-40.938c1.611-2.699,0.441-3.555-2.239-3.538
		c-3.313,0.02-6.64,0.189-9.933-0.065c-3.933-0.305-6.369,1.115-8.377,4.633c-6.401,11.216-13.204,22.202-19.724,33.354
		c-1.464,2.503-4.873,5.273-3.521,7.715C181.272,98.616,185.482,96.36,188.503,97.093z M331.874,97.069
		c3.35-0.9,7.903,1.807,10.415-2.276c8.332-13.539,16.39-27.246,24.539-40.896c1.415-2.371,0.905-3.752-2.068-3.753
		c-3.478-0.001-6.975,0.205-10.429-0.088c-3.85-0.327-6.053,1.307-7.926,4.552c-6.46,11.185-13.249,22.18-19.712,33.362
		c-1.507,2.608-5.184,5.351-3.499,8.131C324.58,98.386,328.768,96.596,331.874,97.069z M143.867,50.112
		c-9.739,0.001-9.75-0.007-14.596,8.079c-5.264,8.784-10.6,17.526-15.703,26.403c-2.102,3.657-7.113,7.887-5.367,10.971
		c2.04,3.598,8.176,0.82,12.48,1.412c3.998,0.55,6.312-1.32,8.274-4.737c6.414-11.171,13.163-22.148,19.678-33.263
		c1.468-2.505,4.839-5.323,3.547-7.689C150.633,48.457,146.421,50.73,143.867,50.112z M71.298,49.94
		c-3.134,1.196-7.637-1.818-10.215,2.437c-8.238,13.597-16.317,27.289-24.442,40.955c-1.594,2.68-0.297,3.594,2.317,3.607
		c3.312,0.017,6.643-0.195,9.932,0.089c4.01,0.346,6.344-1.325,8.318-4.756c6.358-11.052,13.085-21.891,19.494-32.914
		c1.538-2.644,5.107-5.551,3.726-8.146C78.972,48.478,74.645,50.689,71.298,49.94z M107.597,49.969
		c-3.567,1.021-8.146-1.824-10.852,2.678C88.636,66.139,80.61,79.681,72.547,93.201c-1.463,2.453-0.823,3.722,2.079,3.734
		c3.479,0.015,6.975-0.179,10.436,0.091c3.844,0.298,6.015-1.37,7.892-4.62c6.462-11.192,13.237-22.204,19.799-33.339
		c1.485-2.521,4.832-5.38,3.639-7.712C114.885,48.407,110.641,50.789,107.597,49.969z M403.256,96.979
		c11.059-0.138,8.894,1.067,14.307-7.906c6.841-11.343,13.611-22.729,20.333-34.143c2.37-4.025,1.942-4.68-2.763-4.798
		c-2.813-0.071-5.649,0.192-8.44-0.067c-4.139-0.387-6.672,1.199-8.764,4.858c-6.325,11.067-13.084,21.887-19.493,32.906
		c-1.528,2.627-5.194,5.468-3.648,8.119C396.299,98.541,400.619,96.478,403.256,96.979z M367.653,96.814
		c7.555,2.011,11.692-1.705,14.303-8.137c0.493-1.213,1.338-2.282,2.017-3.42c6.109-10.243,12.188-20.506,18.347-30.719
		c1.879-3.115,1.289-4.532-2.478-4.431c-3.146,0.084-6.318,0.251-9.438-0.054c-4.046-0.397-6.354,1.36-8.309,4.758
		c-6.362,11.053-13.046,21.92-19.443,32.954c-1.53,2.64-5.168,5.481-3.707,8.123C360.437,98.584,364.756,96.428,367.653,96.814z
		 M456.817,52.769c-0.461-0.166-0.922-0.331-1.383-0.495c-8.326,14.014-16.685,28.007-24.941,42.061
		c-1.242,2.114,0.457,2.576,2.112,2.589c4.464,0.035,8.927,0.011,13.392-0.027c1.168-0.01,2.416-0.142,3.132-1.188
		c2.977-4.352,7.09-8.54,7.481-13.775C457.335,72.26,456.817,62.494,456.817,52.769z M26.422,81.129
		c0.436,0.127,0.871,0.256,1.306,0.384c5.557-9.367,11.116-18.731,16.666-28.102c1.432-2.416,0.415-3.298-2.072-3.28
		c-4.14,0.027-8.279,0.032-12.419,0.031c-2.201,0-3.464,1.032-3.47,3.274C26.407,62.667,26.422,71.898,26.422,81.129z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#596E73"
        d="M57.058,0.394c-1.845,6.21-0.242,12.608-1.027,18.876
		c-9.938,0.019-19.876,0.03-29.815,0.061c-7.537,0.022-7.817,0.276-7.817,7.835c-0.008,125.724-0.007,251.449,0.001,377.173
		c0,2.307-0.222,4.658,0.933,6.813c1.954,1.132,4.117,0.918,6.23,0.922c10.146,0.02,20.292,0.011,30.438,0.012
		c0.021,5.973,0.042,11.946,0.063,17.92c-18.232,0-36.464,0-54.696,0c0.071-3.146,0.204-6.291,0.204-9.437
		C1.582,283.03,1.604,145.492,1.48,7.954C1.476,3.046,2.604,1.346,7.783,1.478c14.242,0.358,28.499,0.156,42.75,0.08
		c1.865-0.01,4.026,0.792,5.531-1.164C56.395,0.394,56.727,0.394,57.058,0.394z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3D494D"
        d="M481.697,1.388c0,141.381-0.018,282.761,0.093,424.142
		c0.003,3.729-0.832,4.629-4.569,4.577c-16.737-0.234-33.479-0.102-50.22-0.102c0.086-1.255,0.172-2.51,0.258-3.765
		c15.073-0.079,30.148-0.293,45.22-0.153c4.735,0.045,6.804-1.591,6.29-6.336c-0.123-1.147-0.015-2.318-0.015-3.478
		c0.001-134.695,0.002-269.391-0.008-404.085c0-2.649-0.123-5.298-0.189-7.946c0.76-0.883,1.521-1.765,2.28-2.647
		C481.111,1.474,481.397,1.404,481.697,1.388z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6F888F"
        d="M427.259,426.24c-0.086,1.255-0.172,2.51-0.258,3.765
		c-0.994,0-1.989,0-2.983,0c-0.002-5.632,0.144-11.269-0.065-16.893c-0.117-3.172,0.717-4.231,4.135-4.124
		c9.432,0.296,18.884-0.073,28.317,0.214c4.009,0.122,5.405-0.859,5.327-5.126c-0.265-14.736-0.101-29.48-0.101-44.222
		c0-110.312,0-220.623-0.004-330.935c0-2.151-0.054-4.305-0.082-6.457c0.692-0.782,1.385-1.565,2.077-2.349
		c1.596,2.582,1.114,5.465,1.115,8.247c0.022,66.26,0.018,132.521,0.018,198.782c0,59.303,0.004,118.606-0.009,177.91
		c-0.001,6.788-0.264,7.034-6.966,7.057c-8.448,0.029-16.898,0.109-25.344-0.023c-3.759-0.06-5.59,1.325-5.372,5.215
		C427.23,420.275,427.201,423.261,427.259,426.24z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3B474B"
        d="M382.899,425.895c0.114,1.369,0.23,2.739,0.345,4.11
		c-94.144,0-188.286,0-282.43,0c0.014-1.312,0.029-2.623,0.043-3.935c84.25-0.015,168.499-0.026,252.747-0.051
		C363.369,426.017,373.135,425.938,382.899,425.895z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6B848A"
        d="M100.726,22.15c-2.754,0.869-3.501-0.442-3.461-2.974
		c0.078-4.946-0.039-9.896,0.017-14.843c0.028-2.513-0.873-3.774-3.542-3.175c-0.171-0.286-0.133-0.542,0.114-0.766
		c2.32,0,4.641,0,6.961,0c2.174,1.816,4.771,0.998,7.162,0.999c91.449,0.06,182.896,0.063,274.344,0.074
		c0.221,0.945,0.441,1.892,0.662,2.837C293.729,4.308,204.474,4.263,115.22,4.359c-16.073,0.018-14.491-2.803-14.303,15.029
		C100.854,20.309,100.79,21.229,100.726,22.15z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6F898F"
        d="M100.857,426.07c-0.014,1.312-0.029,2.623-0.043,3.935
		c-1.326,0-2.651,0-3.978,0c1.021-5.754,0.335-11.557,0.433-17.334c0.045-2.686,0.719-3.681,3.684-3.677
		c92.631,0.104,185.264,0.1,277.895,0.157c1.828,0.001,4.839-1.108,4.043,2.853c-2.979,0.038-5.957,0.106-8.936,0.106
		c-86.567,0.006-173.135-0.034-259.702,0.043C99.328,412.167,100.722,409.677,100.857,426.07z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#B7C4C7"
        d="M56.063,0.394c-1.505,1.956-3.666,1.154-5.531,1.164
		c-14.25,0.076-28.507,0.278-42.75-0.08C2.604,1.346,1.476,3.046,1.48,7.954C1.604,145.492,1.582,283.03,1.571,420.568
		c0,3.146-0.133,6.291-0.204,9.437c-2.054-0.894-0.932-2.686-0.934-3.974c-0.072-46.195-0.061-92.392-0.061-138.587
		c0-94.212,0.029-188.425-0.104-282.637C0.265,0.95,1.271,0.254,4.902,0.298C21.954,0.512,39.009,0.394,56.063,0.394z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#B7C4C7"
        d="M382.32,1.467c-91.448-0.012-182.896-0.015-274.344-0.074
		c-2.391-0.001-4.988,0.817-7.162-0.999c93.812,0,187.624,0,281.436,0c0.026,0.355,0.052,0.711,0.078,1.066L382.32,1.467z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#647B81"
        d="M386.228,430.005c0.09-0.317,0.173-0.637,0.27-0.951
		c0.773-2.527-1.498-6.778,1.848-7.426c3.942-0.762,8.695-2.393,12.334,1.97c1.767,2.117,4.949,2.391,6.651,0.321
		c2.72-3.307,6.056-2.597,9.421-2.799c4.016-0.239,4.604,1.582,3.179,4.827c-8.193-0.515-16.379,1.206-24.591-0.007
		c-2.861-0.424-5.396,0.222-5.134,4.064C388.88,430.005,387.554,430.005,386.228,430.005z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6B848A"
        d="M382.328,1.46c-0.026-0.355-0.052-0.711-0.078-1.066
		c2.32,0,4.641,0,6.961,0c7.838,2.309,15.853,0.537,23.773,0.972c2.334,0.129,4.916,0.823,7.056-0.972c0.331,0,0.663,0,0.994,0
		c-1.351,1.046-0.473,2.702-1.083,3.952c-3.678,0-7.355,0-11.695,0c1.237,2.182,2.018,3.558,2.798,4.934
		c-3.494-0.956-6.446-5.203-10.667-1.764c-0.285-4.63-3.814-2.972-6.26-3.101c-3.35-0.176-3.987,2.147-3.945,4.877
		c-3.772,1.054-3.655-1.478-3.493-3.888C386.902,2.177,386.189,0.117,382.328,1.46z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3B474B"
        d="M93.452,425.823c0.134,1.394,0.268,2.788,0.402,4.182
		c-9.945,0-19.89,0-29.834,0c-0.636-3.089,1.039-4.151,3.749-4.108c3.056,0.05,6.109,0.245,9.163,0.377
		C82.438,426.124,87.945,425.974,93.452,425.823z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3B474B"
        d="M390.205,430.005c-0.263-3.843,2.272-4.488,5.134-4.064
		c8.212,1.213,16.397-0.508,24.591,0.007c0.037,1.353,0.073,2.704,0.11,4.058C410.095,430.005,400.15,430.005,390.205,430.005z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#677F85"
        d="M76.931,426.273c-3.054-0.132-6.107-0.327-9.163-0.377
		c-2.709-0.043-4.385,1.02-3.749,4.108c-1.326,0-2.652,0-3.978,0c-0.006-0.165-0.046-0.337-0.013-0.494
		c0.571-2.7-1.717-7.046,1.603-7.833c3.871-0.917,8.793-2.485,12.284,2.007c0.627,0.807,1.997,1.036,3.023,1.531
		C76.937,425.568,76.934,425.921,76.931,426.273z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#B7C4C7"
        d="M481.697,1.388c-0.3,0.017-0.586,0.086-0.86,0.207
		c-18.961-0.062-37.922-0.121-56.883-0.183c-0.31-0.34-0.62-0.679-0.931-1.019c18.397,0,36.795-0.04,55.191,0.105
		C479.24,0.508,481.15-1.09,481.697,1.388z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#B7C4C7"
        d="M93.854,0.394c-0.247,0.224-0.285,0.479-0.114,0.766
		c0-0.001-0.099,0.122-0.099,0.122C82.422,1.322,71.203,1.365,59.983,1.408c-0.312-0.338-0.624-0.677-0.936-1.015
		C70.649,0.394,82.251,0.394,93.854,0.394z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#B7C4C7"
        d="M420.04,0.394c-2.14,1.795-4.722,1.101-7.056,0.972
		c-7.921-0.435-15.936,1.337-23.773-0.972C399.487,0.394,409.764,0.394,420.04,0.394z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M100.917,19.389c-0.188-17.832-1.77-15.012,14.303-15.029
		c89.254-0.097,178.509-0.052,267.763-0.056c-0.023,4.951-0.047,9.902-0.069,14.854c-3.144,0.057-6.286,0.16-9.429,0.161
		C282.628,19.35,191.773,19.368,100.917,19.389z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M100.857,426.07c-0.136-16.394-1.53-13.903,13.396-13.917
		c86.567-0.077,173.135-0.037,259.702-0.043c2.979,0,5.957-0.068,8.936-0.106c0.003,4.631,0.005,9.26,0.008,13.891
		c-9.765,0.044-19.53,0.122-29.295,0.125C269.356,426.044,185.107,426.056,100.857,426.07z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3B474B"
        d="M19.333,411.151c-1.155-2.155-0.932-4.507-0.933-6.813
		c-0.008-125.724-0.009-251.449-0.001-377.173c0-7.559,0.281-7.813,7.817-7.835c9.938-0.03,19.877-0.042,29.815-0.061
		c0.251,3.537-2.377,2.956-4.414,2.971c-8.285,0.06-16.572,0.143-24.853-0.015c-3.392-0.063-4.978,1.1-4.665,4.573
		c0.104,1.15,0.003,2.317,0.003,3.479c0,124.104-0.001,248.208,0.008,372.313c0,2.149,0.129,4.301,0.199,6.452
		C21.317,409.746,20.325,410.448,19.333,411.151z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M152.68,97.091c-3.016-0.729-7.219,1.522-8.807-1.327
		c-1.355-2.433,1.989-5.255,3.452-7.755c6.521-11.149,13.355-22.118,19.771-33.326c2.017-3.522,4.463-4.917,8.387-4.618
		c3.293,0.251,6.621,0.081,9.933,0.063c2.65-0.014,3.883,0.791,2.251,3.524c-8.148,13.65-16.206,27.356-24.463,40.939
		C160.674,98.751,156.202,96.256,152.68,97.091z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M322.495,49.99c3.061,0.748,7.263-1.54,8.85,1.343
		c1.361,2.474-2.056,5.217-3.52,7.723c-6.519,11.151-13.275,22.165-19.718,33.359c-1.868,3.244-4.019,4.933-7.88,4.614
		c-3.456-0.285-6.952-0.087-10.43-0.07c-2.697,0.013-3.832-0.898-2.239-3.566c8.152-13.649,16.239-27.337,24.484-40.931
		C314.604,48.237,319.055,50.922,322.495,49.99z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M260.157,97.102c-3.046-0.748-7.27,1.521-8.829-1.338
		c-1.31-2.404,2.084-5.198,3.559-7.704c6.635-11.284,13.484-22.443,20.043-33.77c1.815-3.135,4.025-4.475,7.604-4.226
		c3.464,0.242,6.956,0.087,10.436,0.067c2.8-0.017,3.729,1.062,2.201,3.626c-8.144,13.663-16.206,27.375-24.495,40.95
		C268.145,98.853,263.633,96.176,260.157,97.102z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M224.679,97.071c-3.198-0.54-7.504,1.416-9.045-1.087
		c-1.63-2.648,2.027-5.489,3.54-8.101c6.46-11.146,13.227-22.113,19.656-33.276c1.873-3.251,4.074-4.854,7.897-4.549
		c3.448,0.275,6.933,0.088,10.402,0.074c2.696-0.011,3.826,0.939,2.256,3.576c-8.113,13.624-16.188,27.27-24.383,40.845
		C232.445,98.789,228.037,96.193,224.679,97.071z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M188.503,97.093c-3.021-0.732-7.23,1.523-8.809-1.328
		c-1.352-2.441,2.057-5.212,3.521-7.715c6.52-11.151,13.322-22.138,19.724-33.354c2.008-3.518,4.444-4.938,8.377-4.633
		c3.293,0.255,6.621,0.085,9.933,0.065c2.68-0.017,3.85,0.839,2.239,3.538c-8.147,13.652-16.206,27.357-24.467,40.938
		C196.492,98.767,192.017,96.242,188.503,97.093z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M331.874,97.069c-3.106-0.474-7.294,1.316-8.68-0.969
		c-1.685-2.78,1.992-5.522,3.499-8.131c6.463-11.183,13.252-22.178,19.712-33.362c1.873-3.245,4.076-4.879,7.926-4.552
		c3.454,0.293,6.951,0.087,10.429,0.088c2.974,0.001,3.483,1.382,2.068,3.753c-8.149,13.65-16.207,27.357-24.539,40.896
		C339.777,98.876,335.224,96.169,331.874,97.069z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M143.867,50.112c2.554,0.618,6.766-1.655,8.313,1.176
		c1.292,2.366-2.079,5.185-3.547,7.689c-6.515,11.114-13.264,22.092-19.678,33.263c-1.962,3.417-4.276,5.287-8.274,4.737
		c-4.305-0.592-10.441,2.186-12.48-1.412c-1.747-3.084,3.265-7.313,5.367-10.971c5.103-8.877,10.439-17.619,15.703-26.403
		C134.117,50.105,134.128,50.113,143.867,50.112z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M71.298,49.94c3.347,0.749,7.674-1.463,9.13,1.272
		c1.381,2.595-2.188,5.502-3.726,8.146c-6.409,11.023-13.136,21.862-19.494,32.914c-1.974,3.431-4.308,5.102-8.318,4.756
		c-3.289-0.284-6.62-0.072-9.932-0.089c-2.614-0.014-3.912-0.928-2.317-3.607c8.125-13.666,16.205-27.358,24.442-40.955
		C63.661,48.122,68.164,51.137,71.298,49.94z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M107.597,49.969c3.044,0.82,7.288-1.562,8.794,1.387
		c1.192,2.332-2.154,5.19-3.639,7.712c-6.562,11.135-13.337,22.146-19.799,33.339c-1.877,3.25-4.048,4.918-7.892,4.62
		c-3.46-0.27-6.956-0.076-10.436-0.091c-2.902-0.013-3.542-1.281-2.079-3.734c8.063-13.521,16.089-27.063,24.198-40.555
		C99.451,48.145,104.03,50.989,107.597,49.969z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M403.256,96.979c-2.637-0.502-6.957,1.562-8.469-1.03
		c-1.546-2.651,2.12-5.492,3.648-8.119c6.409-11.02,13.168-21.839,19.493-32.906c2.092-3.659,4.625-5.245,8.764-4.858
		c2.791,0.26,5.627-0.004,8.44,0.067c4.705,0.118,5.133,0.772,2.763,4.798c-6.722,11.414-13.492,22.8-20.333,34.143
		C412.149,98.047,414.314,96.842,403.256,96.979z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M367.653,96.814c-2.897-0.387-7.217,1.77-8.708-0.925
		c-1.461-2.642,2.177-5.483,3.707-8.123c6.397-11.034,13.081-21.901,19.443-32.954c1.955-3.397,4.263-5.155,8.309-4.758
		c3.119,0.305,6.292,0.138,9.438,0.054c3.767-0.102,4.356,1.315,2.478,4.431c-6.159,10.213-12.237,20.476-18.347,30.719
		c-0.679,1.138-1.523,2.207-2.017,3.42C379.346,95.109,375.208,98.825,367.653,96.814z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3D4A4E"
        d="M100.917,19.389c90.856-0.021,181.711-0.039,272.568-0.069
		c3.143-0.001,6.285-0.104,9.429-0.161c0.118,1.725-0.413,2.942-2.38,3.017c-0.993,0.037-1.986,0.071-2.979,0.071
		c-91.449,0.001-182.896-0.002-274.345-0.009c-0.827,0-1.655-0.056-2.483-0.087C100.79,21.229,100.854,20.309,100.917,19.389z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M456.817,52.769c0,9.726,0.518,19.491-0.207,29.163
		c-0.392,5.235-4.505,9.424-7.481,13.775c-0.716,1.047-1.964,1.179-3.132,1.188c-4.465,0.038-8.928,0.063-13.392,0.027
		c-1.655-0.013-3.354-0.475-2.112-2.589c8.257-14.054,16.615-28.047,24.941-42.061C455.896,52.438,456.356,52.603,456.817,52.769z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#323232"
        d="M26.422,81.129c0-9.23-0.015-18.462,0.011-27.692
		c0.006-2.242,1.27-3.274,3.47-3.274c4.14,0.001,8.28-0.004,12.419-0.031c2.486-0.018,3.503,0.864,2.072,3.28
		c-5.55,9.37-11.109,18.734-16.666,28.102C27.293,81.385,26.858,81.256,26.422,81.129z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6F888F"
        d="M423.954,1.412c18.961,0.062,37.922,0.121,56.883,0.183
		c-0.76,0.883-1.521,1.765-2.28,2.647c-15.074,0.014-30.151,0.157-45.224-0.037c-4.78-0.063-6.7,1.693-6.292,6.402
		c0.257,2.964,0.194,5.955,0.274,8.935c-0.11,0.903-0.222,1.805-0.332,2.708c-2.648,0.666-3.021-0.796-2.999-2.975
		C424.047,13.322,423.974,7.367,423.954,1.412z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#647B81"
        d="M390.14,22.175c-3.235,1.074-3.825-0.792-3.494-3.322
		c0.279-2.137-1.368-5.632,2.823-5.497c4.033,0.13,8.368-1.517,11.841,2.666c1.926,2.319,5.036,1.483,7.011-0.751
		c3.275-3.704,7.502-2.146,11.04-1.602c2.669,0.41,0.493,3.608,0.585,5.555c-8.181-0.01-16.363-0.047-24.545-0.01
		C393.157,19.224,390.584,18.871,390.14,22.175z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#677F85"
        d="M63.028,22.274c-4.384,0.938-2.899-2.418-2.957-4.306
		c-0.057-1.895-1.039-4.837,2.562-4.616c4.041,0.248,8.419-1.538,11.841,2.718c1.713,2.131,4.901,1.701,6.628-0.44
		c3.334-4.134,7.715-2.406,11.447-2.011c2.795,0.298,0.714,3.53,0.902,5.44c-8.363,0.032-16.726,0.069-25.089,0.095
		C65.97,19.161,63.667,19.287,63.028,22.274z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6B848A"
        d="M390.019,417.351c-5.096,0.82-2.918-3.098-3.297-5.212
		c-0.393-2.2,0.493-3.242,3.018-3.195c9.108,0.174,18.222,0.164,27.334,0.129c2.209-0.009,3.615,0.412,2.965,3.032
		c-4.571,0.022-9.143,0.046-13.716,0.068c-1.152,0.001-2.302,0.003-3.452,0.005c-2.311,0.01-4.633,0.172-6.93-0.004
		C392.105,411.881,389.867,413.19,390.019,417.351z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#718A91"
        d="M62.818,417.368c-5.099,0.203-2.091-3.666-2.685-5.618
		c-0.62-2.037,0.643-2.792,2.766-2.763c9.188,0.125,18.377,0.13,27.566,0.118c2.033-0.003,3.723,0.119,3.063,2.874
		c-4.809,0.067-9.618,0.134-14.428,0.2c-1.107,0-2.211,0-3.316,0c-2.257-0.003-4.53,0.171-6.765-0.049
		C65.042,411.741,62.838,413.196,62.818,417.368z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#718A91"
        d="M19.333,411.151c0.993-0.703,1.985-1.405,2.977-2.108
		c10.085,0.026,20.17,0.058,30.255,0.076c2.017,0.004,4.273-0.322,3.436,2.966c-10.146-0.001-20.292,0.008-30.438-0.012
		C23.449,412.069,21.287,412.283,19.333,411.151z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3D4A4E"
        d="M426.983,22.25c0.11-0.903,0.222-1.805,0.332-2.709
		c5.411-0.072,10.83-0.324,16.235-0.168c6.691,0.194,13.436-0.895,20.071,0.741c-0.692,0.783-1.385,1.566-2.077,2.349
		C450.024,22.393,438.504,22.321,426.983,22.25z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#718A91"
        d="M59.983,1.408c11.22-0.043,22.439-0.086,33.658-0.127
		c-0.074,0.988-0.147,1.977-0.22,2.965c-4.438-0.094-8.901,0.317-13.294-0.686c-1.791-0.001-3.579,0-5.368,0.001
		c-1.928,0.102-3.925,0.575-5.77,0.231c-4.689-0.875-6.283,1.196-5.975,5.522c-1.59,0.261-3.028,0.368-2.973-1.957
		C60.089,5.377,60.007,3.393,59.983,1.408z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3D4A4E"
        d="M63.028,22.274c0.639-2.987,2.942-3.113,5.334-3.12
		c8.363-0.025,16.727-0.063,25.089-0.095c0.395,3.423-2.035,3.169-4.194,3.176C80.514,22.266,71.771,22.265,63.028,22.274z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#3D4A4E"
        d="M390.14,22.175c0.444-3.304,3.018-2.951,5.261-2.961
		c8.182-0.037,16.364,0,24.545,0.01c0.352,3.511-2.237,2.992-4.267,2.998C407.166,22.25,398.652,22.198,390.14,22.175z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4F6267"
        d="M406.324,412.173c4.571-0.022,9.143-0.046,13.714-0.068
		c1.03,4.203-0.378,6.22-4.907,5.588c-1.6-0.224-3.23-0.229-4.848-0.333c-0.383-1.129-1.079-1.939-2.273-2.245
		c0,0,0.004,0.243,0.004,0.242C407.976,414.016,407.084,413.13,406.324,412.173z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#647B81"
        d="M76.931,426.273c0.002-0.353,0.005-0.705,0.008-1.058
		c1.672-0.168,3.422-0.42,4.467-1.823c3.06-4.106,7.333-2.104,10.995-1.965c2.533,0.096,1.3,2.734,1.051,4.396
		C87.945,425.974,82.438,426.124,76.931,426.273z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4F6267"
        d="M79.102,412.181c4.809-0.067,9.617-0.134,14.426-0.201
		c1.101,4.604-0.902,6.268-5.346,5.708c-1.436-0.181-2.893-0.2-4.34-0.294C83.551,414.484,80.892,413.727,79.102,412.181z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M80.128,3.563c4.391,1.001,8.854,0.59,13.292,0.684
		c1.083,4.094-0.528,5.751-4.667,5.281c-1.601-0.182-3.229-0.13-4.845-0.184C83.576,6.811,80.904,5.807,80.128,3.563z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4F6267"
        d="M62.818,417.368c0.021-4.172,2.224-5.627,6.201-5.237
		c2.235,0.22,4.508,0.046,6.766,0.049c-1.792,1.54-4.41,2.329-4.741,5.203C68.301,417.827,65.559,417.815,62.818,417.368z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#4F6267"
        d="M390.019,417.351c-0.151-4.16,2.087-5.47,5.922-5.177
		c2.297,0.176,4.619,0.014,6.933,0.003c-2.008,1.339-4.488,2.262-4.646,5.244C395.486,417.832,392.751,417.799,390.019,417.351z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M63.015,9.315c-0.309-4.326,1.285-6.397,5.975-5.522
		c1.845,0.344,3.842-0.13,5.772-0.233c-0.778,2.241-3.435,3.256-3.781,5.783C68.325,9.334,65.67,9.324,63.015,9.315z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M411.054,9.279c-0.78-1.376-1.561-2.752-2.798-4.934
		c4.34,0,8.018,0,11.695,0c0.949,3.814-0.278,5.717-4.448,5.178C414.034,9.334,412.537,9.355,411.054,9.279z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M390.182,9.292c-0.042-2.729,0.596-5.053,3.945-4.877
		c2.445,0.129,5.975-1.529,6.26,3.101c0,0,0.021-0.07,0.02-0.07c-1.352,0.082-2.355,0.78-3.185,1.79
		C394.875,9.254,392.528,9.272,390.182,9.292z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#647B81"
        d="M70.98,9.343c0.346-2.527,3.003-3.542,3.781-5.783
		c1.786,0.001,3.574,0,5.365,0.001c0.777,2.246,3.449,3.25,3.782,5.783C79.6,5.594,75.29,5.741,70.98,9.343z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#647B81"
        d="M71.044,417.383c0.331-2.874,2.949-3.663,4.741-5.203
		c1.104,0,2.208,0,3.315,0c1.792,1.547,4.45,2.305,4.742,5.214C79.579,413.698,75.313,413.907,71.044,417.383z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#677F85"
        d="M398.228,417.421c0.157-2.982,2.638-3.905,4.646-5.244
		c1.147-0.001,2.297-0.003,3.449-0.004c0.762,0.957,1.653,1.843,1.691,3.184C404.131,413.102,401.144,415.096,398.228,417.421z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#6B848A"
        d="M397.222,9.235c0.829-1.01,1.833-1.708,3.185-1.79
		C399.705,8.684,399,9.915,397.222,9.235z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#677F85"
        d="M408.01,415.114c1.194,0.306,1.891,1.116,2.273,2.245
		C408.988,417.155,408.408,416.227,408.01,415.114z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        fill="#566B70"
        d="M463.622,20.114c-6.636-1.636-13.38-0.547-20.071-0.741
		c-5.405-0.156-10.824,0.096-16.235,0.168c-0.08-2.979-0.018-5.97-0.274-8.934c-0.408-4.709,1.512-6.465,6.292-6.402
		c15.072,0.194,30.149,0.051,45.224,0.037c0.066,2.648,0.189,5.297,0.189,7.946c0.01,134.694,0.009,269.39,0.008,404.085
		c0,1.159-0.108,2.33,0.015,3.478c0.514,4.745-1.555,6.381-6.29,6.336c-15.071-0.14-30.146,0.074-45.22,0.153
		c-0.058-2.979-0.028-5.965-0.194-8.938c-0.218-3.89,1.613-5.274,5.372-5.215c8.445,0.133,16.896,0.053,25.344,0.023
		c6.702-0.022,6.965-0.269,6.966-7.057c0.013-59.304,0.009-118.607,0.009-177.91c0-66.262,0.005-132.522-0.018-198.782
		C464.736,25.579,465.218,22.696,463.622,20.114z"
      />
      <rect x="22.103" y="30.277" fill-rule="evenodd" clip-rule="evenodd" width="439.632" height="194.783" />
    </g>
  </svg>
);

export default Window;
